const vulnerability = [
    [false, false], [true, false], [false, true], [true, true],
    [true, false], [false, true], [true, true], [false, false],
    [false, true], [true, true], [false, false], [true, false],
    [true, true], [false, false], [true, false], [false, true]
];

export function getBoardInfo(number) {
    const normalizedNumber = (parseInt(number) - 1) % 16;
    return {
        dealer: normalizedNumber % 4,
        //As single vulns
        NSVuln: vulnerability[normalizedNumber][0],
        EWVuln: vulnerability[normalizedNumber][1],
        //As array 0 => NSVuln, 1 => EWVuln
        vulnerability: vulnerability[normalizedNumber]
    };
}

export function computeScore(board, level, suit, doubled, decla, result) {
    let score = 0;
    if (level > 0) {                                                // otherwise "all pass" and nothing to do
        const gamarr = [300, 500];
        const slmarr = [500, 750, 1000, 1500];
        let side = decla % 2;
        let vuln = getBoardInfo(board).vulnerability[side] ? 1 : 0;
        let fact = 0;

        if (result < 0) {                                                // declarer went down
            if (doubled > 0) {
                fact = (vuln > 0) ? 3 : 2;
                score = (fact * result + 1) * 100;                        // score ALWAYS negative
                if (doubled > 1) score *= 2;
                if ((vuln < 1) && (result < -3)) {                       // additional for absurd no-vuln calls
                    let extra = (result + 3) * 100;
                    if (doubled > 1) extra *= 2;
                    score += extra;
                }
            } else {
                score = 50 * result * (1 + vuln);
            }
        } else {                                                      // contract made or more (result >= 0)
            let bonus = 0;
            score = 20 * level;                                         // dtart computing the VALUE of the contract
            if ([2, 3, 4].includes(suit)) score += 10 * level;
            if (suit === 4) {                                           // this is the pure value of the contract
                score += 10;
            }
            if (doubled > 0) {
                score *= 2 * doubled;
                bonus = (doubled === 1) ? 50 : 100;                        // premium for double/surdouble and made
            }
            if (score < 100) {
                bonus += 50;                                             // premium for PARTIAL contract made
            } else {
                score += gamarr[vuln];                                  // if game or slam add the premium
                if (level >= 6) {
                    score += slmarr[2 * (level - 6) + vuln];
                }
            }
            score += bonus;
            if (result > 0) {
                if (doubled > 0) {
                    fact = (vuln > 0) ? 200 : 100;
                    if (doubled > 1) fact *= 2;
                } else {
                    fact = [2, 3, 4].includes(suit) ? 30 : 20;
                }
                score += fact * result;
            }
        }
        if (side > 0) {
            score = -score;
        }
        return score;
    } else {
        return 0;
    }
}
